"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.avatarTroubleshootingGroupLabels = exports.avatarTroubleshootingGroupDisplayOrder = exports.troubleshootingResolvedVia = exports.avatarTroubleshootingGroups = void 0;
exports.avatarTroubleshootingGroups = [
    'disabled',
    'enabled_intro',
    'enabled_test_task',
    'enabled_main_task',
    'enabled_survey',
    'terminal',
];
exports.troubleshootingResolvedVia = ['worker_id', 'phone_number', 'access_code'];
exports.avatarTroubleshootingGroupDisplayOrder = [
    'disabled',
    'enabled_intro',
    'enabled_test_task',
    'enabled_main_task',
    'enabled_survey',
    'terminal',
];
exports.avatarTroubleshootingGroupLabels = {
    disabled: 'Disabled',
    enabled_intro: 'Enabled — Intro',
    enabled_test_task: 'Enabled — Test task',
    enabled_main_task: 'Enabled — Main task',
    enabled_survey: 'Enabled — Survey',
    terminal: 'Ended',
};
//# sourceMappingURL=Index.js.map